// extracted by mini-css-extract-plugin
module.exports = {"GreenBox":"Submit_GreenBox__sbisa","sucessText":"Submit_sucessText__GyLeC","sucessSubText":"Submit_sucessSubText__WAE7q"};